declare const jobData: any; // from localized JSON_small file

import * as JobTypes from "../types/jobData";

// Pattern: Singleton
/* What does FilterProcessData? 
-----------------------------
- It processes the given jobData and counts the different categories. 
- Saves the counts in a dictionary. 
- Updates the DOM with the new filter counts.  
- From here, the rendering of the filter sidebar will take place. (So, if a filter is not added here, it will not be rendered in the sidebar.)

/* What does it not do? 
-----------------------
- It does not handle active filters. This will be done in filterStateManager.ts
*/
export class FilterProcessData {
  private static instance: FilterProcessData;
  private filterCounts: Record<string, Record<string, number>> = {};

  private constructor() {}

  public static getInstance(): FilterProcessData {
    if (!FilterProcessData.instance) {
      FilterProcessData.instance = new FilterProcessData();
    }
    return FilterProcessData.instance;
  }

  /**
   * MUST BE CALLED WITH all jobs without any filters applied. 
   * This means that we have all categories. Then we will only update the category count.
   
   */
  public initializeAllCategories(jobs: JobTypes.jobData[]) {
    this.updateCategoryData(jobs);
  }

  /* Updates Known Data about Categories */
  public updateCategoryData(jobs: JobTypes.jobData[]) {
    this.resetAllCounts(); // Reset for new Data

    for (const job of jobs) {
      this.countCategories("workingTimes", job.jobOpening.workingTimes);
      this.countCategories("jobLevel", job.jobOpening.targetGroups);
      this.countCategories("jobOpening", job.jobOpening.categories);
    }
  }

  /**
   * Counts every Category and saves it in the filterCounts dictionary
   */
  private countCategories(category: string, items: JobTypes.Category[]) {
    if (!items) return;
    if (!this.filterCounts[category]) this.filterCounts[category] = {};

    items.forEach((item) => {
      // (Logical OR Fallback) Method
      this.filterCounts[category][item.name] = (this.filterCounts[category][item.name] || 0) + 1;
    });
  }

  public getSortedFilterCounts(): Record<string, Record<string, number>> {
    let sortedFilterCounts: Record<string, Record<string, number>> = {};

    for (const category in this.filterCounts) {
      sortedFilterCounts[category] = Object.fromEntries(
        Object.entries(this.filterCounts[category]).sort(([a], [b]) => a.localeCompare(b))
      );
    }

    return sortedFilterCounts;
  }

  /**
   * Resets all counts in the filterCounts dictionary to 0.
   */
  private resetAllCounts() {
    for (const category in this.filterCounts) {
      if (this.filterCounts[category]) {
        for (const itemName in this.filterCounts[category]) {
          this.filterCounts[category][itemName] = 0;
        }
      }
    }
  }

  // public returnFilterCategoryHTML(name: string, count: number) {
  //   let slugID = name.replace(/\s+/g, "-").toLowerCase();

  //   return `
  //     <div class="dt-filter-sidebar__checkbox-row">
  //       <input type="checkbox" id="${slugID}" name="${slugID}" class="dt-filter-sidebar__checkbox-row-input">
  //       <label for="${slugID}" class="dt-filter-sidebar__checkbox-row-label">${name}</label>
  //       <div class="dt-filter-sidebar__checkbox-row-count">${count}</div>
  //     </div>
  //   `;
  // }
}
